<template>
    <div class="rich-text-editor" v-loading="loading">
      <el-row>
          <el-col :md="24" :lg="12">
            <span class="employer-name">
                <a :href="props.job.employer_url">
                    {{ props.job.employer_name }}
                </a>
                /Job {{ props.job.job_id }}</span>

              <a :href="url(`admin/jobs/${props.job.job_id}`)" target="_blank">
                  (open job detail)
              </a>
          </el-col>
          <el-col :md="12" :lg="8" style="padding-bottom:5px">
              <el-button type="primary"
                         :disabled="!props.job.pagination.prevId"
                         @click="redirectTo(props.job.pagination.prevId)"
                         size="small"><i class="fa fa-angle-left"></i></el-button>
              <span style="font-size:14px;padding:0 5px;">{{ props.job.pagination.actualJob }} / {{ props.job.pagination.totalJobs }}</span>
              <el-button type="primary"
                         :disabled="!props.job.pagination.nextId"
                         @click="redirectTo(props.job.pagination.nextId)"
                         size="small"><i class="fa fa-angle-right"></i></el-button>
          </el-col>
          <el-col :md="12" :lg="4">
            <template v-if="props.job.is_current_version">
                <el-button v-if="!publishing" :type="changed ? `danger` : `info`" size="small" style="float: right;" @click="publish">Publish</el-button>
                <el-button v-else type="info" disabled size="small" style="float: right;">Publishing</el-button>
            </template>
            <template v-else>
                <el-button v-if="!publishing" type="danger" size="small" style="float: right;" @click="publish">Use this version</el-button>
                <el-button v-else type="info" disabled size="small" style="float: right;">Publishing</el-button>
            </template>
          </el-col>
        </el-row>

          <el-tabs v-model="tab" type="card">
            <el-tab-pane label="Copy" name="description">
                <froala :tag="'textarea'" :config="config" v-model="props.description"></froala>
            </el-tab-pane>
            <el-tab-pane label="Title" name="title">
                <editor-panel-title :data="props.job"></editor-panel-title>
            </el-tab-pane>
            <el-tab-pane label="Template" name="job-template">
                <editor-panel-job-template 
                    :data="props.job" 
                    :landing_page_template_list="landing_page_template_list" 
                    :props="props" 
                    @refresh="refresh"
                    @change="styleChanged"
                ></editor-panel-job-template>
            </el-tab-pane>
            <el-tab-pane label="Versions" name="versions">
                <editor-panel-versions :data="props.job.versions" :version_id="props.job.version_id"></editor-panel-versions>
            </el-tab-pane>
            <el-tab-pane label="Overrides" name="employer-overrides">
                <editor-panel-overrides></editor-panel-overrides>
            </el-tab-pane>
          </el-tabs>
    </div>
</template>

<style lang="less">
    .rich-text-editor {
        padding: 10px;

        .employer-name {
            font-size: 1.3em;
        }
    }
</style>
<script>
    export default {
        props: [
            'props'
        ],
        methods: {
            refresh() {
                this.loading = true;

                axios.get(url(`/admin/job-board/landing-page-templates/${this.props.job.job_id}`), {
                    params: {
                        job_board_landing_page_template_id: this.props.job.job_board_landing_page_template_id
                    }
                }).then((response) => {
                    this.props.job.landing_page_template = response.data.landing_page_template;
                    this.landing_page_template_list = response.data.landing_page_template_list;

                    this.styleChanged();
                }).finally(() => {
                    this.loading = false;
                    this.changed = false;
                });
            },
            publish() {
                let data = this.props.job;
                let publishUrl = this.props.url_base + '/publish';
                data.copy = this.props.description;
                this.publishing = true;
                axios.post(publishUrl, { data: data })
                    .then(t => {
                        this.publishing = false;
                        this.changed = false;
                        if (!this.props.job.is_current_version) {
                            window.location.replace(window.location.origin + window.location.pathname);
                        }

                        this.refresh();
                    });
            },
            redirectTo(jobId) {
                window.location.href = window.url_base_redirect.replace('%job_id%', jobId);
            },
            styleChanged() {

                // images
                $('.cs-images').detach();
                let html = '';
                let lpTemplate = this.props.job.landing_page_template;

                if (lpTemplate.hero[0]) {
                    let image = lpTemplate.hero[0];
                    this.props.hero_image = image.url;

                    let hero_position = 'top left';
                    if (lpTemplate.hero_position) {
                        hero_position = lpTemplate.hero_position;
                    }

                    html +=`
                    .img-job-hero {
                        background-image: url(${image.url}) !important;
                        background-position: ${hero_position} !important;
                    }`
                }

                // form left/right
                if (lpTemplate.form_position) {
                    let position = lpTemplate.form_position;
                    let position2 = position === 'left' ? 'right' : 'left';
                    html +=`
                        .lp-viewport.default-style .info-section-1 .form-area {
                            float: ${position};
                        }
                        .lp-viewport.default-style .info-section-1 .info-section-left {
                            float: ${position2};
                        }`
                }

$('body').append(
                    $('<style/>', {
                        class: 'cs-images',
                        html: html
                    })
                );

                // colors
                let color = lpTemplate.color;

                $('.cs-color-style').detach();
                $('body').append(
                    $('<style/>', {
                        class: 'cs-color-style',
                        html: `
                        .bg-color {
                            background-color: ${color} !important;
                        }
                        .bg-color-hover:hover {
                            background-color: ${color} !important;
                        }
                        .fg-color {
                            color: ${color} !important;
                        }
                        .fg-color-hover:hover {
                            color: ${color} !important;
                        }
                        .border-color {
                            border-color: ${color} !important;
                        }
                        `
                    })
                );

                // styles
                let styles = lpTemplate.styles;
                $('.cs-styles').detach();
                $('body').append(
                    $('<style/>', {
                        class: 'cs-styles',
                        html: styles
                    })
                );
            }
        },
        watch: {
            props: {
                handler: function(newValue) {
                    this.changed = true;
                },
                deep: true
            },
        },
        mounted() {
            this.refresh();

            window.onbeforeunload = e => {
                if (this.changed) {
                    return "You should keep this page open.";
                }
                else {
                    return null;
                }
            };
        },
        data () {
            let tab = 'description';
            if (!this.props.job.is_current_version) {
                tab = 'versions';
            }

            return {                
                loading: true,
                landing_page_template_list: [],

                tab: tab,
                publishing: false,
                changed: false,
                config: {
                    key: 'CA4D4A2D3E1D2tA6B4B3A1C7D1G2E1E4A3oa2Pe2HTPYh1RNc2E1KDc1==',
                    events: {
                        'froalaEditor.initialized': function () {
                            console.log('initialized')
                        }
                    },
                    enter: $.FroalaEditor.ENTER_BR,
                    toolbarSticky: false,

                    toolbarButtons: ['fullscreen', 'bold', 'italic', 'underline', 'strikeThrough', '|', 'fontSize', 'color', '|', 'paragraphFormat', 'align', 'formatOL', 'formatUL', 'outdent', 'indent',
                        'insertTable', 'insertHR', 'clearFormatting', '|', 'help', 'html', '|', 'undo', 'redo'],
                    htmlRemoveTags: ['script', 'style', 'base'],
                    pasteDeniedTags: ['script', 'style', 'base', 'div', 'span', 'dl', 'dt', 'dd'],
                    pasteDeniedAttrs: ['class', 'id', 'style', 'dir'],

                    // always clean on Word paste (not giving a choice)
                    wordPasteModal: false,
                    wordPasteKeepFormatting: false
                }
            }
        }
    }
</script>
